import React from "react";
import { Container, Nav, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";
import ListUser from "./ListUser";
import ListKorwil from "./ListKorwil";
import ListAreaManager from "./ListAreaManager";
import ListSupervisor from "./ListSupervisor";
import ListMarketing from "./ListMarketing";
import ListBPD from "./ListBPD";
import "./UsersMonitoring.css";

const tabs = [
  { key: "user", title: "User", icon: "users", component: ListUser, adminOnly: true },
  { key: "korwil", title: "Koordinator Wilayah", icon: "map-marked-alt", component: ListKorwil },
  { key: "areamaneger", title: "Area Manager", icon: "user-tie", component: ListAreaManager },
  { key: "supervisor", title: "Supervisor", icon: "user-shield", component: ListSupervisor },
  { key: "marketing", title: "Sales Marketing", icon: "bullhorn", component: ListMarketing },
  { key: "korcab", title: "BPD", icon: "university", component: ListBPD },
];

export default function IndexUser() {
  const role = useSelector((state) => state.authReducer.role);
  const [activeTab, setActiveTab] = React.useState("");
  const availableTabs = tabs.filter((tab) => !tab.adminOnly || role === "super admin");
  const selected = availableTabs.some((tab) => tab.key === activeTab) ? activeTab : availableTabs[0].key;
  return <Container fluid className="users-page"><section className="users-monitor" aria-label="Monitoring pengguna">
    <header className="users-hero">
      <div><span className="users-eyebrow">MONITORING TIM & AKSES</span><h1>Manajemen Pengguna</h1><p>Pantau status akun, penempatan, dan akses tim dalam satu halaman.</p></div>
      <span className="users-hero-tag"><i className="fas fa-users" aria-hidden="true" /> Direktori tim Bank Kalbar</span>
    </header>
    {!role ? <div className="users-empty" role="status">Memuat data pengguna…</div> : <Tab.Container id="users-monitor-tabs" activeKey={selected} onSelect={setActiveTab} mountOnEnter>
      <Nav className="users-tabs" role="tablist" aria-label="Kategori pengguna">
        {availableTabs.map((tab) => <Nav.Item key={tab.key}><Nav.Link eventKey={tab.key}><i className={`fas fa-${tab.icon}`} aria-hidden="true" />{tab.title}</Nav.Link></Nav.Item>)}
      </Nav>
      <Tab.Content>{availableTabs.map(({ key, component: Component }) => <Tab.Pane key={key} eventKey={key}><Component /></Tab.Pane>)}</Tab.Content>
    </Tab.Container>}
  </section></Container>;
}
